import React from 'react';
import Card from './Card';
import useTranslation from '../i18n/useTranslation';
import '../styles/pixel-art.css';

const PlayerHand = ({ cards, onCardClick, selectedCards = [], selectionMode = false, maxSelection = 0 }) => {
  const { t } = useTranslation();

  if (!cards || cards.length === 0) {
    return null;
  }

  const handleCardClick = (card) => {
    if (selectionMode && onCardClick) {
      onCardClick(card);
    }
  };

  const isCardSelected = (card) => {
    return selectedCards.some(c => c.id === card.id);
  };

  const isCardDisabled = (card) => {
    if (!selectionMode) return true;
    if (isCardSelected(card)) return false;
    if (maxSelection > 0 && selectedCards.length >= maxSelection) return true;
    return false;
  };

  return (
    <div className="player-hand">
      {selectionMode && (
        <div className="selection-info">
          <span>
            {maxSelection > 0
              ? t.hand.selectCards
                  .replace('{count}', maxSelection)
                  .replace('{plural}', maxSelection > 1 ? 's' : '')
              : 'cards'}
          </span>
          {maxSelection > 0 && (
            <span className="selection-count">
              {t.hand.selectionCount
                .replace('{selected}', selectedCards.length)
                .replace('{total}', maxSelection)}
            </span>
          )}
        </div>
      )}
      <div className="hand-cards">
        {cards.map((card) => (
          <Card
            key={card.id}
            card={card}
            onClick={handleCardClick}
            selected={isCardSelected(card)}
            disabled={isCardDisabled(card)}
          />
        ))}
      </div>
    </div>
  );
};

export default PlayerHand;
